const warmedUrls = new Set<string>();

function getImageHost(url: string): string | null {
  try {
    return new URL(url).origin;
  } catch {
    return null;
  }
}

function ensureDocument(): boolean {
  return typeof document !== "undefined";
}

export function prefetchImages(urls: Array<string | null | undefined>): void {
  if (!ensureDocument()) return;
  for (const url of urls) {
    if (!url || warmedUrls.has(url)) continue;
    if (getImageHost(url) === null) continue;
    warmedUrls.add(url);
    const img = new Image();
    img.decoding = "async";
    img.src = url;
  }
}
